import { render, staticRenderFns } from "./LocalPaymentMethods.vue?vue&type=template&id=27c12260&scoped=true"
import script from "./LocalPaymentMethods.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalPaymentMethods.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LocalPaymentMethods.vue?vue&type=style&index=0&id=27c12260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c12260",
  null
  
)

export default component.exports